import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { ButtonLink } from "@/components/Interface/Button/Button";
import { ProductCard } from "@/components/Layout/BaseLayouts/ProductCard/ProductCard";
import { ProductCardHeader } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardHeader";

export interface DeviceProductCardProps {
  dataTestid: string;
  icon: ReactNode;
  title: string;
  subtitle?: string;
  note?: ReactNode;
  chips?: ReactNode;
  headerClassName?: string;
  navigationTarget?: string;
  buttonText?: string;
  footer: ReactNode;
  className?: string;
}

/**
 * The ProductCard-based shell shared by every device-status tile (Active,
 * Suspended, Inactive, ...). Kept separate from the legacy `DeviceTile` since
 * meta/promo/purchase-intent tiles still depend on that one unchanged.
 */
export const DeviceProductCard = ({
  dataTestid,
  icon,
  title,
  subtitle,
  note,
  chips,
  headerClassName,
  navigationTarget,
  buttonText,
  footer,
  className,
}: DeviceProductCardProps) => {
  const { t } = useTranslation("portal");

  return (
    <div data-testid="device-product-tile" className={className}>
      <ProductCard
        dataTestid={dataTestid}
        header={
          <ProductCardHeader
            icon={icon}
            title={title}
            subtitle={subtitle}
            note={note}
            chips={chips}
            className={headerClassName}
            action={
              navigationTarget && (
                <ButtonLink to={navigationTarget} variant="secondary" size="sm">
                  {buttonText || t("layout.tiles.manage")}
                </ButtonLink>
              )
            }
          />
        }
        footer={footer}
      />
    </div>
  );
};
